export default __webpack_public_path__ + "static/media/bg_giftHeader.880c9e94.svg";